<template>
  <base-card tabled>
    <template v-slot:header>
      <base-card-heading>Security</base-card-heading>
    </template>
    <base-stats v-model="stats" />
    <template v-if="project.securities.length">
      <base-table>
        <thead>
          <tr>
            <th>Security</th>
            <th>Charge</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(security, key) in project.securities" :key="key">
            <td>{{ security.name }}</td>
            <td>{{ security.charge }}</td>
            <td>{{ $formatting.toCurrency(security.amount) }}</td>
          </tr>
        </tbody>
      </base-table>
    </template>
    <template v-else>
      <div class="p-3 text-center">No securities added yet.</div>
    </template>
    <div class="border-top bg-light py-3 text-center">
      Last Updated: {{ lastUpdated }}
    </div>
  </base-card>
</template>

<script>
import { mapState } from 'vuex'

import StatGrid from './StatGrid.vue'

export default {
  created () {
    this.calculate()
  },

  data: () => ({
    stats: []
  }),

  name: 'ProjectSecurityBreakdown',

  components: {
    StatGrid
  },

  props: {
    facility: Object
  },

  computed: {
    lastUpdated () {
      let date

      this.project.securities.forEach(({ updatedAt }) => {
        let updated = this.$moment(updatedAt)
        if (!date || updated.isBefore(date)) {
          date = updated
        }
      })

      return this.$dates.toDateTime(date)
    },

    ...mapState({
      project: store => store.core.projects.entity
    })
  },

  methods: {
    calculate () {
      this.stats = [
        {
          stat: this.$formatting.toCurrency(this.getTotalSecurity()),
          text: 'Total Security'
        },
        {
          stat: this.$formatting.toCurrency(this.getHeadroom()),
          text: 'Headroom facility + revenue'
        },
        {
          stat: `${this.getFacilityCoverage()}%`,
          text: 'Security Coverage of Facility'
        },
        {
          stat: `${this.getFacilityRevenueCoverage()}%`,
          text: 'Coverage Facility + Revenue'
        }
      ]
    },

    getCoverage (coverage) {
      const security = this.getTotalSecurity()
      const diff = coverage - security

      if (diff <= 0.00) {
        return '100.00'
      }

      return new this.$big(security).div(coverage).times(100).toFixed(2)
    },

    getFacilityRevenueCoverage () {
      const facility = this.project.facility.amount
      const revenue = this.facility.getTotalRevenue()
      const total = this.$big(facility).plus(revenue).toString()

      return this.getCoverage(total)
    },

    getFacilityCoverage () {
      const facility = this.project.facility.amount

      return this.getCoverage(facility)
    },

    getHeadroom () {
      const facility = this.project.facility.amount
      const revenue = this.facility.getTotalRevenue()
      const security = this.getTotalSecurity()
      const total = this.$big(facility).plus(revenue).toString()

      if (this.$big(total).gt(security)) {
        return 0
      }

      return this.$big(security).minus(total).toFixed(2)
    },

    getTotalSecurity () {
      const amounts = []

      this.project.securities.forEach(({ amount }) => amounts.push(this.$_.toNumber(amount)))

      return this.$_.sum(amounts)
    }
  }
}
</script>
